module.exports = __webpack_public_path__ + "img/empty.20afdd31.png";